import { render, staticRenderFns } from "./Sensory_overload_spot.vue?vue&type=template&id=7b6c00b2&"
import script from "./Sensory_overload_spot.vue?vue&type=script&lang=js&"
export * from "./Sensory_overload_spot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports